import { render, staticRenderFns } from "./A.vue?vue&type=template&id=c108cb16&scoped=true"
import script from "./A.vue?vue&type=script&lang=js"
export * from "./A.vue?vue&type=script&lang=js"
import style0 from "./A.vue?vue&type=style&index=0&id=c108cb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c108cb16",
  null
  
)

export default component.exports